import { useTranslation } from 'react-i18next';

export default function WelcomeCard() {
  const { t } = useTranslation();

  return (
    <div className="flex justify-center px-1 pb-1">
      <div className="relative w-full max-w-[360px]">
        <div className="absolute -top-8 left-1/2 -translate-x-1/2 z-10">
          <div
            className="w-16 h-16 rounded-full overflow-hidden"
            style={{ filter: 'drop-shadow(0 8px 20px rgba(168,85,247,0.26))' }}
          >
            <img
              src="https://public.readdy.ai/ai/img_res/693c1c87-a74f-4b39-bf98-c93f412a248c.png"
              alt="AI 画师"
              className="w-full h-full object-cover"
            />
          </div>
        </div>

        <div
          className="rounded-[24px] px-5 pt-10 pb-5 text-center relative overflow-hidden"
          style={{
            background: 'rgba(255,255,255,0.95)',
            backdropFilter: 'blur(20px)',
            border: '1px solid rgba(255,107,157,0.08)',
            boxShadow: '0 14px 34px rgba(17,24,39,0.06)',
          }}
        >
          <h2 className="text-base font-bold text-gray-800 mb-2 tracking-wide">
            {t('chat_welcomeCardTitle', '您好！我是AI画师')}
          </h2>

          <p className="text-[13px] text-gray-500 leading-relaxed">
            {t('chat_welcomeCardLine1', '告诉我你想要的画面，')}
            {t('chat_welcomeCardLine2', '我会帮你创作出惊艳的作品')}
          </p>
        </div>
      </div>
    </div>
  );
}
